<div class="relative bg-[#0A0E1F] text-white font-sans py-24 px-6 md:px-12 lg:px-20 overflow-hidden">
  <!-- Desktop SVG (with curve) -->
  <div class="absolute inset-0 pointer-events-none hidden md:block">
    <svg width="100%" height="100%" viewBox="0 0 1510 737" xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none">
      <g filter="url(#filter0_n_2895_2874)">
        <path d="M-2 0H515L628.5 51.5H755H879.5L997 0H1510V737H-2V0Z" fill="#1B223B" />
      </g>
      <defs>
        <filter id="filter0_n_2895_2874" x="-2" y="0" width="1512" height="737" filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feTurbulence type="fractalNoise" baseFrequency="0.66 0.66" stitchTiles="stitch" numOctaves="3" seed="576"
            result="noise" />
          <feComponentTransfer in="noise" result="coloredNoise1">
            <feFuncR type="linear" slope="2" intercept="-0.5" />
            <feFuncG type="linear" slope="2" intercept="-0.5" />
            <feFuncB type="linear" slope="2" intercept="-0.5" />
            <feFuncA type="discrete"
              tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0" />
          </feComponentTransfer>
          <feComposite operator="in" in="coloredNoise1" in2="shape" result="noise1Clipped" />
          <feComponentTransfer in="noise1Clipped" result="color1">
            <feFuncA type="table" tableValues="0 0.15" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode in="shape" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
      </defs>
    </svg>
  </div>

  <!-- Mobile SVG (rectangle noise only) -->
  <div class="absolute inset-0 pointer-events-none block md:hidden">
    <svg width="100%" height="100%" viewBox="0 0 389 990" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <g filter="url(#filter0_n_3081_4663)">
        <rect width="390" height="990" fill="#1B223B" />
      </g>
      <defs>
        <filter id="filter0_n_3081_4663" x="0" y="0" width="390" height="990" filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feTurbulence type="fractalNoise" baseFrequency="0.66 0.66" stitchTiles="stitch" numOctaves="3" seed="8391"
            result="noise" />
          <feComponentTransfer in="noise" result="coloredNoise1">
            <feFuncR type="linear" slope="2" intercept="-0.5" />
            <feFuncG type="linear" slope="2" intercept="-0.5" />
            <feFuncB type="linear" slope="2" intercept="-0.5" />
            <feFuncA type="discrete"
              tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0" />
          </feComponentTransfer>
          <feComposite operator="in" in2="shape" in="coloredNoise1" result="noise1Clipped" />
          <feComponentTransfer in="noise1Clipped" result="color1">
            <feFuncA type="table" tableValues="0 0.15" />
          </feComponentTransfer>
          <feMerge result="effect1_noise_3081_4663">
            <feMergeNode in="shape" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
      </defs>
    </svg>
  </div>

  <!-- Divider: only for desktop -->
  <div class="hidden md:block absolute top-[40px] bottom-0 w-[5px] bg-[#0A0E1F] left-1/2 -translate-x-1/2 z-10"></div>

  <!-- Content -->
  <div class="max-w-6xl mx-auto grid md:grid-cols-2 relative z-20">
    <!-- Left Side - Contact -->
    <div class="contact-form pr-0 md:pr-12 order-1 mb-10 md:mb-0">
      <h4 class="text-[#19E4E0] font-semibold uppercase tracking-wide">
        <span class="border-b-2 border-[#19E4E0]">Contact Us</span>
      </h4>
      <h2 class="text-2xl md:text-3xl font-bold mt-2">
        Get in Touch with HighRollers
      </h2>
      <p class="text-gray-400 text-sm md:text-base mt-2 mb-8 leading-relaxed">
        Have questions or need support? Our team is here to help. Reach out
        anytime for assistance with your account, games, or promotions—we’re
        just a message away!
      </p>
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="space-y-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- First Name -->
          <div>
            <label class="block text-white mb-2 text-sm font-medium">First Name</label>
            <input type="text" formControlName="firstName" placeholder="Enter your first name"
              class="w-full px-4 py-3 rounded-md bg-[#1B223B] border border-teal-400 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400" />
            <div *ngIf="
                contactForm.get('firstName')?.touched &&
                contactForm.get('firstName')?.invalid
              " class="text-red-500 text-xs mt-1">
              First name is required.
            </div>
          </div>

          <!-- Last Name -->
          <div>
            <label class="block text-white mb-2 text-sm font-medium">Last Name</label>
            <input type="text" formControlName="lastName" placeholder="Enter your last name"
              class="w-full px-4 py-3 rounded-md bg-[#1B223B] border border-teal-400 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400" />
            <div *ngIf="
                contactForm.get('lastName')?.touched &&
                contactForm.get('lastName')?.invalid
              " class="text-red-500 text-xs mt-1">
              Last name is required.
            </div>
          </div>
        </div>

        <!-- Email & Phone in one row -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Email -->
          <div>
            <label class="block text-white mb-2 text-sm font-medium">Email</label>
            <input type="email" formControlName="email" placeholder="Enter your email"
              class="w-full px-4 py-3 rounded-md bg-[#1B223B] border border-teal-400 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400" />
            <div *ngIf="
                contactForm.get('email')?.touched &&
                contactForm.get('email')?.invalid
              " class="text-red-500 text-xs mt-1">
              Please enter a valid email.
            </div>
          </div>

          <!-- Phone -->
          <div>
            <label class="block text-white mb-2 text-sm font-medium">Phone</label>
            <input type="text" formControlName="phone" placeholder="Enter your phone number"
              class="w-full px-4 py-3 rounded-md bg-[#1B223B] border border-teal-400 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400" />
            <div *ngIf="
                contactForm.get('phone')?.touched &&
                contactForm.get('phone')?.invalid
              " class="text-red-500 text-xs mt-1">
              Phone number is required.
            </div>
          </div>
        </div>

        <!-- Message -->
        <div>
          <label class="block text-white mb-2 text-sm font-medium">Message</label>
          <textarea formControlName="message" placeholder="Write your message" rows="5"
            class="w-full px-4 py-3 rounded-md bg-[#1B223B] border border-teal-400 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400"></textarea>
          <div *ngIf="
              contactForm.get('message')?.touched &&
              contactForm.get('message')?.invalid
            " class="text-red-500 text-xs mt-1">
            Message is required.
          </div>
        </div>

        <!-- Submit Button -->
        <div class="flex justify-center">
          <div class="border-[2px] border-[#19E4E0] rounded-full inline-block p-[4px]">
            <button type="submit" [disabled]="contactForm.invalid"
              class=" px-8 py-[0.5rem] rounded-full shadow-md --button transition disabled:opacity-50">
              Send Message
            </button>
          </div>
        </div>
      </form>
    </div>

    <div
      class="absolute left-[-25px] right-[-30px] h-[5px] bg-[#0A0E1F] top-[62%] -translate-y-1/2 z-10 block md:hidden">
    </div>

    <!-- Right Side - FAQ -->
    <div class="faq-section pl-0 md:pl-12 order-2 mt-10 md:mt-0">
      <h4 class="text-[#19E4E0] font-semibold uppercase tracking-wide">
        <span class="border-b-2 border-[#19E4E0]">FAQ</span>
      </h4>
      <h2 class="text-2xl md:text-3xl font-bold mt-2 mb-8">
        Frequently Asked Questions About Our Gaming Site
      </h2>
      <div class="space-y-6">
        <div *ngFor="let faq of faqs" class="border-b border-[#19E4E0] pb-4">
          <button (click)="toggle(faq.index)"
            class="flex justify-between w-full text-left font-medium text-white focus:outline-none">
            <span>{{ faq.question }}</span>
            <span class="text-white text-2xl font-bold">
              {{ openIndex === faq.index ? "−" : "+" }}
            </span>
          </button>
          <p *ngIf="openIndex === faq.index" class="text-gray-400 mt-2 text-sm leading-relaxed">
            {{ faq.answer }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
